import ApiService from '@/services/api.service';

const GlobalService = {
    getCustomGlobalCodes(param) {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: param.CodeType,
                GROUPCREATION: param.GroupCreation
            }
        };
        return ApiService.customRequest(requestData);
    },

    getGlobalCustom(param) {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: param.CodeType,
                OrderBy: param.OrderBy
            }
        };
        return ApiService.customRequest(requestData);
    },

    getEthnicity() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'ETHNICITY'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getContactType() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'CONTACTTYPE'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getGender() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'GENDER'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getEyeColor() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'EYECOLOR'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getHairColor() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'HAIRCOLOR'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getCommPreference() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'COMMUNICATIONPREF'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getFamilyIncome() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'FAMILYINCOME'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getPersonalIncome() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'PERSONALINCOME'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getMajorLanguage() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'MAJORLANGUAGE'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getMajorLanguageAbility() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'LANGUAGEABILITYMODE'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getMajorReligion() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'MAJORRELIGION'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getDisability() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'DISABILITY'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getLegalStatus() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'LEGALSTATUS'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getEducationStatus() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'EDUCATIONSTATUS'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getNewCropUserTypes() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'NEWCROPUSERTYPE'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getTypeOfReferrals() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'TYPEOFREFERRAL'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getSpecimenType() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'SPECIMEN'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getOrderType() {
        const requestData = {
            method: 'get',
            url: '/GlobalCodes',
            headers: {},
            params: {
                CodeType: 'ORDERTYPE'
            }
        };
        return ApiService.customRequest(requestData);
    },

    getNoteOptions() {
        return ApiService.get(`/NoteOptions/`);
    },

    getPrograms(PatientCode) {
        const requestData = {
            method: 'get',
            url: '/PatientRegistrationSummaries/',
            params: {
                PatientCode: `${PatientCode}`
            }
        };
        return ApiService.customRequest(requestData);
    },

    getNotesTherapies(param) {
        const requestData = {
            method: 'get',
            url: '/NotesTherapies/ByProgram',
            params: {
                SelDateFrom: `${param.DateFrom}`,
                SelDateTo: `${param.DateTo}`,
                ProgramCode: `${param.ProgramCode}`,
                EmployeeCode: `${param.EmployeeCode}`,
                RecordId: `${param.RecordId}`
            }
        };
        return ApiService.customRequest(requestData);
    },

    getNoteTypes(LinkedWithTherapies, Code) {
        return ApiService.get(
            `/NotesTypes?LinkedWithTherapies=${LinkedWithTherapies}&TherapyCode=${Code}`
        );
    },

    getNoteTypesByCustomFrame(parameter) {
        return ApiService.get(
            `/NotesTypes?CustomFrame=${parameter.CustomFrame}&showAll=${parameter.showAll}`
        );
    },

    getNoteTypesByCustomFrameList(parameter) {
        const params = {
            showAll: parameter.showAll,
            CustomFrameEnum: parameter.CustomFrameList
        };
        return ApiService.getWithArray('/NotesTypes', params);
    },

    getNoteTypesOnClinicalNotesReport(LinkedWithTherapies, CustomFrames) {
        const params = {
            LinkedWithTherapies: LinkedWithTherapies,
            CustomFrame: CustomFrames
        };
        return ApiService.getWithArray('/NotesTypes', params);
    },

    getHours(NotesId) {
        return ApiService.get(`/NoteOptions/Hours/?NoteId=${NotesId}`);
    },

    getDateTime() {
        return ApiService.get(`/Providers/GetDateTime`);
    },

    getheaderId() {
        return ApiService.get(`/Utils/GetTimedKey`);
    },

    getCityAndStateByZipCode(ZipCode) {
        return ApiService.get(`/ZipCodes/${ZipCode}`,{ DisableLoading: true });
    },

    UserIsCosigner(NoteId, EmployeeCode) {
        return ApiService.get(
            `/Utils/IsCotherapistRequired/?NoteId=${NoteId}&EmployeeCode=${EmployeeCode}`
        );
    },

    RtfToHtml(rtf) {
        return ApiService.post(`/Utils/RtfToHtml`, rtf);
    },

    getDoctors() {
        return ApiService.get(`/Doctors`);
    },

    getReferrals() {
        return ApiService.get(`/Referrals`);
    },

    getEmployees() {
        return ApiService.get(`/Employees`);
    },
    getEmployeeActive() {
        return ApiService.get(`/Employees/?Active=true`);
    },
    getPatientContacts(PatientCode) {
        return ApiService.get(`/PatientContacts/?PatientCode=${PatientCode}`);
    },

    IsActiveAdmission(recordId) {
        return ApiService.get(`/Utils/IsActiveAdmission?recordId=${recordId}`);
    },

    getAdmissionLastTransactionDate(recordId) {
        return ApiService.get(`/Utils/AdmissionLastTransactionDate?recordId=${recordId}`);
    },

    getTherapies() {
        return ApiService.get(`/NotesTherapies/UsedOnNotes`);
    },

    getFormatSelection(FormatCode) {
        return ApiService.get(`/ExportClinicalPdfFormatSelections?FormatCode=${FormatCode}`);
    },

    getTimeZone() {
        return ApiService.get(`/Providers/GetTimeZone`);
    },

    getIPFSetups() {
        return ApiService.get(`/IPFSetups`);
    },

    duplicateLastSignature(param) {
        const requestData = {
            method: 'get',
            url: '/Utils/DuplicateLastSignature',
            params: {
                UserId: `${param.UserId}`,
                RecordId: `${param.RecordId}`,
                Module: `${param.Module}`
            }
        };
        return ApiService.customRequest(requestData);
    },

    setSignatureHistory(param) {
        return ApiService.post(`/Utils/SetSignatureHistory`, param);
    },

    sendEmail(url, parameters) {
        const paramsStr = this.buildExportParameters(parameters);
        // Concatenar al URL existente
        const fullUrl = `${url}${paramsStr}`;
        return ApiService.get(fullUrl);
    },

    exportCSV(url, parameters) {
        return ApiService.getWithArray(url, parameters);
    },

    exportToPdf(reportHeader, params) {
        const paramsStr = this.buildParameters(reportHeader, params);
        return ApiService.get(`/Utils/exportToPdf${paramsStr}`);
    },

    sendPdfEmail(params) {
        const paramsStr = this.buildExportParameters(params);
        return ApiService.get(`/Utils/sendPdfToEmail${paramsStr}`);
    },

    buildParameters(reportHeader, params = []) {
        const searchParams = new URLSearchParams();

        // Agregar parámetros obligatorios
        searchParams.append('ReportName', reportHeader.reportName);

        // Agregar flags opcionales solo si son true
        if (reportHeader.isAnAPIReport) {
            searchParams.append('IsAnAPIReport', 'true');
        }

        if (reportHeader.isANotesReport) {
            searchParams.append('IsANotesReport', 'true');
        }

        // Agregar parámetros dinámicos
        params.forEach(param => {
            searchParams.append(param.paramName, param.paramValue);
        });

        const queryString = searchParams.toString();
        return queryString ? `?${queryString}` : '';
    },

    buildExportParameters(params) {
        const searchParams = new URLSearchParams();

        // Parámetros requeridos (con validación)
        if (!params.to) {
            return '';
        }
        searchParams.append('To', params.to);

        // Parámetros opcionales (solo si existen y no están vacíos)
        const optionalParams = ['cc', 'subject', 'body', 'url'];
        optionalParams.forEach(key => {
            const value = params[key];
            if (value && typeof value === 'string' && value.trim() !== '') {
                // Capitalizar la primera letra del key para coincidir con el formato original (CC, Subject, etc.)
                const paramKey = key.charAt(0).toUpperCase() + key.slice(1);
                searchParams.append(paramKey, value.trim());
            }
        });

        const queryString = searchParams.toString();
        return queryString ? `?${queryString}` : '';
    },

    getSettings() {
        return ApiService.get(`/Utils/GetSettings`);
    },

    getAssessment() {
        return ApiService.get(`/OutComeStudyTests`);
    },

    getTestRSS(PatientCode) {
        return ApiService.get(`/Providers/LabInterfaceURL/${PatientCode}`);
    },

    getMailOptionSetups() {
        return ApiService.get(`/MailOptionSetups`);
    }
};

export default GlobalService;
